export default __webpack_public_path__ + "static/media/header-md.0b6a0986.webp";